import React, { useRef } from 'react';
import AnimateHeight from 'react-animate-height';

export interface ITextInputCommonProps {
    label?: string;
    className?: string;
    style?: React.CSSProperties;
    inputType?: 'text' | 'password';
    error?: string;
    isRequired?: boolean;
}

interface ITextInputBaseProps extends ITextInputCommonProps {
    name?: string;
    value?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const TextInputBase = (props: ITextInputBaseProps) => {
    const inputRef = useRef(null);

    let className = `dlc-form-textbox-input`;

    let labelClass = inputRef.current && !!inputRef.current.value ? 'reduced ' : '';
    labelClass += props.isRequired ? 'required ' : '';
    if (props.error) {
        labelClass += props.error ? 'error' : '';
        className = props.error ? 'error ' : '';
    }

    return (
        <div className={`dlc-form-textbox-wrapper ${props.className || ''}`} style={props.style}>
            <div className="dlc-form-textbox">
                <input
                    className={className}
                    ref={inputRef}
                    value={props.value}
                    type={props.inputType ?? 'text'}
                    onChange={props.onChange}
                    autoComplete="off"
                />
                <div className={`dlc-form-textbox-label ${labelClass}`}>{props.label}</div>
            </div>
            <AnimateHeight height={props.error ? 'auto' : 0} duration={300}>
                <div className="dlc-form-textbox-error">{props.error}</div>
            </AnimateHeight>
        </div>
    );
};

export default TextInputBase;



// WEBPACK FOOTER //
// ./src/components/controls/forms/base/TextInputBase.tsx